<p-dialog
  [visible]="visible"
  (visibleChange)="visible = $event"
  [header]="'Contact::CsvImportResultTitle' | abpLocalization"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  [dismissableMask]="true"
  [style]="{ width: '38rem', maxWidth: '95vw' }"
  styleClass="contact-import-result-dialog"
  appendTo="body"
  (onHide)="onHide()">
  @if (loading) {
    <div class="d-flex justify-content-center py-4">
      <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
    </div>
  } @else if (expiredMessage) {
    <div class="d-flex align-items-start gap-2 py-2">
      <i class="pi pi-clock text-muted mt-1" aria-hidden="true"></i>
      <span class="text-muted">{{ expiredMessage }}</span>
    </div>
  } @else if (result?.isFailed) {
    <div class="d-flex align-items-start gap-2 py-2">
      <i class="pi pi-times-circle text-danger mt-1" aria-hidden="true"></i>
      <span>{{ 'Contact::CsvImportFailed' | abpLocalization }}</span>
    </div>
  } @else if (result) {
    <div class="d-flex flex-column gap-2">
      <div class="alert alert-success py-2 mb-0">
        {{ 'Contact::CsvImportCompleted' | abpLocalization }}: {{ result.successCount }}/{{ result.totalRows }}
      </div>
      <div class="alert alert-warning py-2 mb-0" *ngIf="result.failedCount > 0">
        {{ 'Contact::FailedRecordCount' | abpLocalization }}: {{ result.failedCount }}
      </div>
      <div class="alert alert-warning py-2 mb-0" *ngIf="result.skippedForUnknownSegmentCount > 0">
        {{ 'Contact::SkippedForUnknownSegment' | abpLocalization }}:
        {{ result.skippedForUnknownSegmentCount }}
      </div>
      <div class="alert alert-info py-2 mb-0" *ngIf="result.createdSegmentNames?.length">
        {{ 'Contact::CreatedSegments' | abpLocalization }}: {{ result.createdSegmentNames.join(', ') }}
      </div>

      <div *ngIf="result.failedCount > 0" class="table-responsive contact-import-result-dialog__table">
        <table class="table table-sm align-middle mb-0">
          <thead>
            <tr>
              <th class="text-nowrap">{{ 'Contact::FirstName' | abpLocalization }}</th>
              <th class="text-nowrap">{{ 'Contact::LastName' | abpLocalization }}</th>
              <th class="text-nowrap">{{ 'Contact::PhoneNumber' | abpLocalization }}</th>
              <th class="text-nowrap">{{ 'Contact::UnmatchedSegments' | abpLocalization }}</th>
              <th class="text-nowrap">{{ 'Contact::Error' | abpLocalization }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of failedRows">
              <td class="text-nowrap">{{ row.firstName || '-' }}</td>
              <td class="text-nowrap">{{ row.lastName || '-' }}</td>
              <td class="contact-import-result-dialog__cell">
                <div class="contact-import-result-dialog__cell-scroll">{{ row.phoneNumber || '-' }}</div>
              </td>
              <td class="contact-import-result-dialog__cell">
                <div class="contact-import-result-dialog__cell-scroll">
                  {{ row.unmatchedSegmentNames?.length ? row.unmatchedSegmentNames.join(', ') : '-' }}
                </div>
              </td>
              <td>
                @if (row.errorCode) {
                  {{ 'Contact::' + row.errorCode | abpLocalization }}
                } @else {
                  {{ row.error || row.errorWithPhoneNumber || '-' }}
                }
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  }
</p-dialog>
